import { render, staticRenderFns } from "./cancelled-orders.vue?vue&type=template&id=0e0b669c&"
import script from "./cancelled-orders.vue?vue&type=script&lang=js&"
export * from "./cancelled-orders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports